<ngx-spinner></ngx-spinner>
<div
  class="detail-box edit-profile"
  [ngClass]="isActive ? 'active-mobile' : ''"
>
  <div class="mobile_head d-flex align-items-center justify-content-between">
    <!-- <a href="javascript:void()" (click)="remove()" class="back_link">
      <span class="icon-arrow-left"></span>
    </a> -->
    <h4>{{ "EDITPROFILE.EDIT_PROFILE" | translate }}</h4>
    <a
      href="javascript:void(0)"
      (click)="remove()"
      class="text-white font-24"
      mat-dialog-close
    >
      <span class="mdi mdi-close"></span>
    </a>
  </div>
  <div class="d-lg-flex account-body">
    <div class="text-center position-relative image-profile">
      <div class="circle big-profile">
        <!-- <span *ngIf="!base64textString && image"> <img [src]="image" /></span>
        <span *ngIf="!base64textString && !image">
          <img src="assets/images/user.jpg"
        /></span>
        <span *ngIf="image && base64textString">
          <img
            [src]="'data:image/jpg;base64,' + base64textString"
            fallback-src="assets/images/user.jpg"
            alt="..."
        /></span> -->
        <!-- {{image}} -->
   
      
        <span *ngIf="!profileService?.uploadedFile && image">
          <img [src]="image"/>
        </span>
        <span *ngIf="profileService?.uploadedFile ">
          <img
          [src]="profileService?.uploadedFile"
          
          alt="..."
      />
        </span>
      </div>
      <label class="edit-photo">
        <span class="icon-edit"></span>
        <input
          type="file"
          id="file"
          accept="image/*"
          name="file"
          (change)="handleFileSelect($event)"
          required
          #profileImage
          (click)="selectImage()"
        />
      </label>
    </div>
    <div class="profile-detail">
      <form #myForm="ngForm" (ngSubmit)="onUpdate(myForm.valid)">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label>{{ "EDITPROFILE.FULL_NAME" | translate }}</label>
              <input
                maxlength="60"
                class="form-control"
                type="text"
                placeholder="{{ 'EDITPROFILE.PLACEHOLDER_NAME' | translate }}"
                name="name"
                [(ngModel)]="model.name"
                pattern="^[a-zA-Z ]*$"
                #name="ngModel"
                required
              />
              <div
                style="color: red"
                class="validation_div"
                *ngIf="name.errors && (name.dirty || myForm.submitted)"
              >
                <p class="mb-0" *ngIf="name.errors.required">
                  {{ "EDITPROFILE.NAME_REQUIRED" | translate }}
                </p>
                <p class="mb-0" *ngIf="name.errors.pattern">
                  {{ "EDITPROFILE.INVALID_NAME" | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xl-6">
            <div class="form-group">
              <label>{{ "EDITPROFILE.EMAIL" | translate }}</label>
              <input
                pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-zA-Z]{2,8}$"
                maxlength="255"
                class="form-control"
                type="email"
                placeholder="{{ 'EDITPROFILE.PLACEHOLDER_EMAIL' | translate }}"
                name="email"
                [(ngModel)]="model.email"
                #email="ngModel"
                required
              />
              <div
                style="color: red"
                class="validation_div"
                *ngIf="email.errors && (email.dirty || myForm.submitted)"
              >
                <p class="mb-0" *ngIf="email.errors.required">
                  {{ "EDITPROFILE.EMAIL_REQUIRED" | translate }}
                </p>
                <p class="mb-0 red-text" *ngIf="email.errors.pattern">
                  {{ "EDITPROFILE.ENTER_VALID_EMAIL" | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xl-6">
            <div class="form-group position-relative">
              <label>{{ "EDITPROFILE.DATE_OF_BIRTH" | translate }}</label>
              <!-- #docregion toggle -->
              <div class="w-100">
                <input
                  name="dob"
                  [(ngModel)]="model.date_of_birth"
                  #dob="ngModel"
                  [min]="minDate"
                  [max]="maxDate"
                  type="text"
                  matInput
                  [matDatepicker]="picker"
                  class="date-input w-100 form-control"
                  placeholder="{{ 'EDITPROFILE.PLACEHOLDER_DOB' | translate }}"
                  autocomplete="off"
                  required
                  readonly
                  (click)="picker.open()"
                />
                <div class="date-icon">
                  <mat-datepicker #picker></mat-datepicker>
                </div>
              </div>
              <!-- #enddocregion toggle -->
              <div
                style="color: red"
                class="validation_div"
                *ngIf="dob.errors && (dob.dirty || myForm.submitted)"
              >
                <p class="mb-0" *ngIf="dob.errors.required">
                  {{ "EDITPROFILE.DATE_REQUIRED" | translate }}
                </p>
                <p class="mb-0" *ngIf="(maxDate|date)<(model.date_of_birth|date)">
                  {{ "EDITPROFILE.VALID_AGE" | translate }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6 col-xl-6">
            <div class="form-group profile-radio">
              <label class="mb-2">{{ "EDITPROFILE.GENDER" | translate }}</label>
              <mat-radio-group
                name="gender"
                [(ngModel)]="model.gender"
                required
                #gender="ngModel"
              >
                <mat-radio-button [value]="'male'">{{
                  "PERSONAL_INFO.MALE" | translate
                }}</mat-radio-button>
                <mat-radio-button [value]="'female'">{{
                  "PERSONAL_INFO.FEMALE" | translate
                }}</mat-radio-button>
              </mat-radio-group>
              <div
                style="color: red"
                class="validation_div"
                *ngIf="gender.errors && (gender.dirty || myForm.submitted)"
              >
                <p class="mb-0" *ngIf="gender.errors.required">
                  {{ "PERSONAL_INFO.GENDER_REQUIRED" | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 pt-2">
            <button
              class="btn btn-theme"
              [disabled]="disableStatus"
              type="submit"
              value="Update Profile"
            >
              <span class="spin icon-loader" *ngIf="profileService.isLoading">
              </span>
              {{ "EDITPROFILE.UPDATE" | translate }}
            </button>
          </div>
        </div>
      </form>
      <hr />
      <div class="content_box">
        <form (ngSubmit)="onSubmit(signForm.valid)" #signForm="ngForm">
          <div class="form-group position-relative mb-4">
            <div class="code-outer selectdiv">
              <label id="checkError">{{
                "EDITPROFILE.MOBILE" | translate
              }}</label>
              <input
                class="form-control"
                #input
                (keyup)="checkError($event)"
                (ngModelChange)="onInputChange($event)"
                maxlength="15"
                #phone="ngModel"
                (hasError)="hasError($event)"
                [(ngModel)]="models.mobile_number"
                name="phone"
                (countryChange)="onCountryChange($event)"
                (ng2TelOutput)="getNumber($event)"
                (intlTelInputObject)="telInputObject($event)"
                [ng2TelInputOptions]="{ initialCountry: 'in' }"
                ng2TelInput
                required
              />
            </div>

            <div
              style="color: red"
              class="validation_div"
              *ngIf="phone.errors || btnDisable"
            >
              <p class="mb-0 red-text" *ngIf="phone?.touched">
                <span *ngIf="phone?.errors?.required">
                  {{ "SIGNUP_INFO.MOBILE_REQUIRED" | translate }}
                </span>
              </p>

              <p
                class="mb-0 red-text"
                *ngIf="
                  phone?.errors?.pattern ||
                  (btnDisable && isNoSame && !phone?.errors?.required)
                "
              >
                {{ "SIGNUP_INFO.VALID_MOBILE" | translate }}
              </p>
            </div>
          </div>
          <div class="form-group">
            <button
              class="btn btn-theme btn-login"
              [disabled]="
                btnDisable ||
                !signForm.valid ||
                model.mobile_number === mobile_number
              "
              href="javascript:void(0)"
            >
              <span class="spin icon-loader" *ngIf="isLoading"> </span>
              {{ "EDITPROFILE.UPDATE" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
